import { useNavigate } from 'react-router-dom';
import { EMAIL_TEXT } from '../../constants';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div>
      <main style={{ maxWidth: 900, margin: '40px auto', padding: 24, lineHeight: 1.6 }}>
        <h1>Политика обработки персональных данных</h1>
        <p>
          <strong>Версия:</strong> v1.1 · <strong>Сервис:</strong> savetorich
        </p>

        <p>
          <a href={`mailto:` + EMAIL_TEXT}>{EMAIL_TEXT}</a>.<br />
          <strong>Сервис:</strong> savetorich (savetorich.com).
        </p>

        <h2>1. Цели и состав обработки</h2>
        <ul>
          <li>регистрация и вход в аккаунт;</li>
          <li>
            отправка транзакционных писем (подтверждение e-mail, смена пароля, системные сообщения);
          </li>
          <li>(опц.) рассылки — только при отдельном согласии.</li>
        </ul>

        <h2>2. Правовые основания</h2>
        <ul>
          <li>Транзакционные письма — исполнение договора/оферты.</li>
          <li>
            Маркетинг — <strong>согласие</strong> (можно отозвать в любое время).
          </li>
        </ul>

        <h2>3. Локализация данных</h2>
        <p>Первичная запись и хранение ПДн граждан РФ — на серверах в РФ (дата-центры Selectel).</p>

        <h2>4. Передача третьим лицам (поручение обработки)</h2>
        <p>
          Для отправки писем используем <strong>UniSender</strong>. Он получает e-mail, тему/шаблон и
          тех. метаданные. Может привлекать субпроцессоров (в т.ч. за пределами РФ). Передаём
          минимально необходимый объём данных.
        </p>

        <h2>5. Трансграничная передача</h2>
        <p>
          Возможна передача ПДн в иностранные государства для доставки писем через UniSender.
          Передача осуществляется при наличии согласия либо иного основания, с применением
          мер защиты.
        </p>

        <h2>6. Сроки хранения</h2>
        <ul>
          <li>Учётная запись и история транзакций — период действия аккаунта + 12 мес.</li>
          <li>
            Логи отправки у провайдера/у нас — до <code>180</code> дней.
          </li>
          <li>Маркетинговые данные — до отзыва согласия или достижения цели.</li>
        </ul>

        <h2>7. Права пользователя</h2>
        <p>
          Доступ/исправление/удаление, отзыв согласия, сведения о получателях и трансграничной
          передаче: <a href={`mailto:` + EMAIL_TEXT}>{EMAIL_TEXT}</a>.
        </p>

        <h2>8. Безопасность</h2>
        <p>HTTPS, разграничение доступов/ролей, 2FA, VPN к БД, шифрование бэкапов, аудит логов.</p>

        <h2>9. Cookie</h2>
        <p>
          Применяем только технически необходимые cookie (сессия/безопасность, анти-CSRF). Аналитика
          и реклама не используются. Состав — в <a href="/cookie-policy">Политике cookie</a>.
        </p>

        <hr />
        <small>
          Персональные данные первично записываются и хранятся в РФ (Selectel). Письма доставляются
          через UniSender; возможна трансграничная передача.
        </small>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
          <button
            onClick={() => navigate('/')}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
          >
            Вернуться на главную
          </button>
        </div>
      </main>
    </div>
  );
}
